export enum IntervalEvents {
    IntervalStarted = 'core:interval-started',
    IntervalEnded = 'core:interval-ended'
}

export type IntervalStartedData = {
    action: Function,
    actionId: string,
    interval: number
};

export type IntervalEndedData = {
    actionId: string
};
